import { SmartLink, YStack, SizableText, shadowStandard, YStackProps } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { Stack } from 'tamagui'

export type BrandListItemProps = {
  id: string
  title: string
  href: string
  image?: string
  slug: string
  wrapperProps?: YStackProps
}

export const BrandListItem = (props: BrandListItemProps) => {
  return (
    <YStack
      width="100%"
      backgroundColor="$white"
      borderRadius={4}
      {...shadowStandard}
      {...props.wrapperProps}
    >
      <SmartLink
        borderRadius={4}
        py="$3"
        px="$2"
        overflow="hidden"
        Component={YStack}
        href={props.href}
        pressStyle={{
          opacity: 0.8,
          animation: 'quick',
        }}
        $gtMd={{
          py: '$4',
          px: '$2',
        }}
      >
        <YStack justifyContent="center" alignItems="center" gap="$4">
          <Stack p="$2" mx="auto" bc="$white" br="$3" {...shadowStandard}>
            <SolitoImage
              src={props.image || 'https://img.clock.co.uk/640x360'}
              alt={props.title}
              contentFit="contain"
              width={80}
              height={80}
              style={{ borderRadius: 8 }}
            />
          </Stack>

          <SizableText textAlign="center" size="$3" fow="500" numberOfLines={1}>
            {props.title}
          </SizableText>
        </YStack>
      </SmartLink>
    </YStack>
  )
}
